import React, { useEffect, useState } from 'react';
import {
  Button,
  Modal,
  Segment,
  Loader,
  Image,
  List,
  Item,
  Dimmer,
  Message,
} from 'semantic-ui-react';
import loaderImage from '../assets/loader-paragraph.png';
import PropTypes from 'prop-types';
import { useStateValue } from '../context/stateContext';
import { loadAllNumbers, deleteNumber, logout } from '../context/actions';
import { getApiErrorMessage, isUnauthorizedError } from '../utility/apiError';

const ModalNumberList = ({ isOpen, handleClose, handleSelectNumber }) => {
  const [{ numbers, isNumbersFetched }, dispatch] = useStateValue();
  const [errorMessage, setErrorMessage] = useState('');
  const [deletingNumberId, setDeletingNumberId] = useState(null);

  useEffect(() => {
    if (isOpen) {
      showAllNumbers();
    }
    // eslint-disable-next-line
  }, [isOpen]);

  const showAllNumbers = async () => {
    setErrorMessage('');
    if (!isNumbersFetched || !numbers.length) {
      try {
        dispatch(await loadAllNumbers());
      } catch (error) {
        handleProtectedError(error);
      }
    }
  };

  const handleCloseModal = () => {
    setErrorMessage('');
    handleClose();
  };

  const handleProtectedError = (error) => {
    if (isUnauthorizedError(error)) {
      dispatch(logout());
      handleCloseModal();
      return;
    }

    setErrorMessage(getApiErrorMessage(error, { context: 'savedNumbers' }));
  };

  const handleDeleteNumber = async (numberId) => {
    setErrorMessage('');
    setDeletingNumberId(numberId);

    try {
      dispatch(await deleteNumber(numberId));
    } catch (error) {
      handleProtectedError(error);
    } finally {
      setDeletingNumberId(null);
    }
  };

  return (
    <div>
      <Modal
        className="track-numner-list-modal"
        dimmer="blurring"
        open={isOpen}
        onClose={handleCloseModal}
      >
        <Modal.Header>
          <div>Sačuvani brojevi za praćenje:</div>
          <span className="track-number-info">
            (kliknite ili dodirnite broj da biste vidjeli status pošiljke)
          </span>
        </Modal.Header>
        <Modal.Content>
          {!isNumbersFetched && !errorMessage && (
            <Segment>
              <Dimmer active inverted>
                <Loader active inverted>
                  Učitavanje brojeva
                </Loader>
              </Dimmer>
              <Image src={loaderImage} />
            </Segment>
          )}
          {errorMessage && <Message negative content={errorMessage} />}
          {isNumbersFetched && (
            <List divided>
              {numbers.map((number) => (
                <Item className="list-row-padding" key={number._id}>
                  <span
                    className="number-list-section"
                    onClick={() => handleSelectNumber(number.number)}
                  >
                    {number.name} - <b>{number.number}</b>
                  </span>
                  {!number.disabled && (
                    <span
                      className="delete-number-button"
                      onClick={() => handleDeleteNumber(number._id)}
                    >
                      <Button
                        circular
                        basic
                        size="mini"
                        icon="trash alternate outline"
                        color="red"
                        aria-label={`Obriši ${number.name}`}
                        loading={deletingNumberId === number._id}
                        disabled={deletingNumberId !== null}
                      />
                    </span>
                  )}
                </Item>
              ))}
            </List>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={handleCloseModal}>
            Zatvori
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

ModalNumberList.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  handleSelectNumber: PropTypes.func,
};

export default ModalNumberList;
